import { BrowserRouter, Routes, Route} from 'react-router-dom'
import {ThemeProvider, Container} from 'react-bootstrap'

//pages
import Home from './pages/Home'

function App() {
  return (
    <Container>
      <ThemeProvider
        breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
        minBreakpoint='xxs'
      >
      <BrowserRouter>
        <Routes>
          <Route 
            path='/'
            element={<Home/>}
          />
        </Routes>
      </BrowserRouter>
      </ThemeProvider>  
    </Container>
  );
}

export default App;
